// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gQov","placeholdersHeader":"styles_placeholdersHeader__yTvm8","editorStyle":"styles_editorStyle__3sWDL","placeholdersBox":"styles_placeholdersBox__3uolq"};